import React, {useEffect} from "react";
import breadcrumbSchema from "../Schemas/breadcrumbSchema";
import heroImg from '../Images/services-hero.webp'
import SchemaMarkup from "../Components/SchemaMarkup";
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import Services from "../Components/Services";
import StatsBox from "../Components/StatsBox";
import ProcessSection from "../Components/Process";
import AwardsSection from "../Components/AwardsSection";
import Cta from "../Components/Cta";

const ServicesJoondalup = () => {
useEffect(() => {
    document.title =
    "Property Settlement Services Joondalup | LDL Settlement Services";
        
    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
    metaDesc.setAttribute(
    "content",
    "Explore all property settlement services in Joondalup, including residential, private sales, new titles and more. Get trusted, local settlement support."
    );
}
        
    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
    canonical.setAttribute("href", "https://ldlsettlementservices.com.au/services/joondalup/");
}
        
    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) {
    ogTitle.setAttribute(
    "content",
    "Property Settlement Services Joondalup | LDL Settlement Services"
    );
}
        
    const ogDesc = document.querySelector("meta[property='og:description']");
    if (ogDesc) {
    ogDesc.setAttribute(
    "content",
    "Explore all property settlement services in Joondalup, including residential, private sales, new titles and more. Get trusted, local settlement support."
    );
}
        
    const ogUrl = document.querySelector("meta[property='og:url']");
    if (ogUrl) {
    ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/services/joondalup/");
}
        
    const ogImage = document.querySelector("meta[property='og:image']");
    if (ogImage) {
    ogImage.setAttribute(
    "content",
    "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
}
        
    const twitterTitle = document.querySelector("meta[name='twitter:title']");
    if (twitterTitle) {
    twitterTitle.setAttribute(
    "content",
    "Property Settlement Services Joondalup | LDL Settlement Services"
    );
}
        
    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
);
    if (twitterDesc) {
    twitterDesc.setAttribute(
    "content",
    "Explore all property settlement services in Joondalup, including residential, private sales, new titles and more. Get trusted, local settlement support."
    );
}
        
    const twitterImage = document.querySelector("meta[name='twitter:image']");
    if (twitterImage) {
    twitterImage.setAttribute(
    "content",
    "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
    }
}, []);

  const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
 {
    name: "Services in Joondalup"
  }
]);
    return(
        <>
        <SchemaMarkup schema={breadcrumbs} />

        <Header
        showBreadcrumb={true}
        pageName="Services in Joondalup"
      />

      <BreadcrumbMain
      subTitle="OUR SERVICES"
      title="Property Settlement Services in Joondalup"
      description="Our property settlement services in Joondalup provide comprehensive support for residential, commercial and property transfer transactions. We help buyers and sellers manage their property settlements with care and attention to detail."
      image={heroImg}
      showIcons={false}
      extraText="Our experienced settlement helps ensure your property transaction progresses smoothly and efficiently."
    />

    {/**SERVICES GRID */}
    <Services
      isSlider={false}
      basePath="/services/joondalup"
      sliderHeading={<>Our Settlement Services<span> in Joondalup</span></>}
      desc="Professional property settlement solutions for residential, commercial and property transfer needs across Joondalup and Western Australia, handled with accuracy, transparency and care."
    />

    {/**STATS SECTION */}
    <StatsBox
      heading="A Proven Track Record in Joondalup Property Settlements"
      desc="For years, we have helped clients navigate property transactions across Western Australia with confidence, care and attention to detail. Our experienced property settlement agents focus on reliable service, accurate documentation and timely communication. Whether you are buying, selling or transferring property in Joondalup, we work to make every settlement a smooth and well-managed experience."
    />

    {/**HOW WE MAKE IT EASY FOR YOU SECTION */}
    <ProcessSection
        heading={<>How We Make Property <span>Settlement Easy for You</span></>}
        desc="We believe that the property settlement process should be simple, transparent and stress-free. Our team guides you through every step, from your initial enquiry to final settlement."
    />


      {/**AWARDS SECTION */}
   <AwardsSection
     heading="Accredited, Certified, and Award-Winning Settlement Services"
     desc="Our commitment to professional standards, industry knowledge and reliable property settlement services helps us deliver a trusted experience for our clients."
   />

   {/**CTA SECTION */}
    <Cta
      heading=" Ready for a Smooth, Hassle-Free Settlement in Joondalup?"
      desc="Make your next property transaction easier with professional settlement agents in Joondalup. LDL Settlement Services is here to guide you through every step."
    />
        </>
    )
}
export default ServicesJoondalup;